import React from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import { StyledButton } from '../../../Components/Generics.styled';

const NavigationSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const LoginTextFieldContainer = styled.div`
    display: flex;
    width: 900px;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
`;

const Title = styled.div`
    font-size: 30px;
    margin-bottom: 25px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const StyledCheckbox = styled(Checkbox)`
    width: 0px;
`;

const UpdatePaymentModal = (props) => {
    const {
        modalIsOpen,
        setModalIsOpen,
        handleDelete,
        updatePaymentMethod,
        postData,
        setExpirationData,
        expirationData,
        isDefaultPaymentMethod,
        handleCheckboxChange,
    } = props;
    const handleClose = () => {
        setModalIsOpen(false);
    };

    const body = (
        <div style={style}>
            <LoginTextFieldContainer>
                <Title>Update Your Payment Method</Title>
                <Container>
                    <TextField
                        id="expiration-month"
                        label="Expiration Month"
                        defaultValue={expirationData?.expirationMonth}
                        onChange={(e) =>
                            setExpirationData({
                                ...expirationData,
                                expirationMonth: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={expirationData?.expirationMonth === ''}
                    />
                    <br />
                    <TextField
                        id="expiration-year"
                        label="Expiration Year"
                        defaultValue={expirationData?.expirationYear}
                        onChange={(e) =>
                            setExpirationData({
                                ...expirationData,
                                expirationYear: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={expirationData?.expirationYear === ''}
                    />
                    <div
                        style={{
                            marginTop: '20px',
                        }}
                    >
                        <span style={{ paddingRight: '8px' }}>Default Payment Method?</span>

                        <StyledCheckbox
                            checked={isDefaultPaymentMethod?.isDefault}
                            onChange={() => handleCheckboxChange()}
                            name="isDefault?"
                        />
                    </div>
                </Container>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={() => updatePaymentMethod()}
                        disabled={
                            expirationData.expirationMonth === '' ||
                            expirationData.expirationYear === ''
                        }
                    >
                        {postData?.isLoading && postData.type === 'update' ? (
                            <CircularProgress
                                style={{ height: '20px', width: '20px', color: 'white' }}
                                color="primary"
                            />
                        ) : (
                            'Update'
                        )}
                    </StyledButton>
                </div>
                {
                    <div
                        style={{
                            marginTop: '16px',
                            marginLeft: '300px',
                            marginBottom: '8px',
                            color: postData.error ? 'red' : 'green',
                            fontSize: '13px',
                        }}
                    >
                        {postData.message && postData.message.length >= 1
                            ? postData.message.map((item, idx) => <div key={idx}>{item}</div>)
                            : postData.message}
                    </div>
                }

                <br />
            </LoginTextFieldContainer>

            <NavigationSection>
                <StyledButton onClick={() => handleClose()} variant="contained" color="primary">
                    Cancel
                </StyledButton>
                <StyledButton variant="contained" color="primary" onClick={() => handleDelete()}>
                    {postData?.isLoading && postData.type === 'delete' ? (
                        <CircularProgress
                            style={{ height: '20px', width: '20px', color: 'white' }}
                            color="primary"
                        />
                    ) : (
                        'Delete'
                    )}
                </StyledButton>
            </NavigationSection>

            <UpdatePaymentModal />
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

UpdatePaymentModal.propTypes = {
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    handleDelete: propTypes.func,
    handleCheckboxChange: propTypes.func,
    isDefaultPaymentMethod: propTypes.shape({
        isDefault: propTypes.bool,
        methodId: propTypes.string,
    }),
    updatePaymentMethod: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
        type: propTypes.string,
        message: propTypes.array,
    }),
    setExpirationData: propTypes.func,
    expirationData: propTypes.shape({
        expirationYear: propTypes.string,
        expirationMonth: propTypes.string,
    }),
};

UpdatePaymentModal.defaultProps = {
    modalIsOpen: false,
    setModalIsOpen: () => {},
    handleDelete: () => {},
    updatePaymentMethod: () => {},
    postData: {
        isLoading: false,
        success: false,
        error: false,
        type: '',
    },
    setExpirationData: () => {},
    expirationData: {
        expirationYear: '',
        expirationMonth: '',
    },
};
export default UpdatePaymentModal;
